import { create } from 'zustand';
import { CreativeOfCampaign } from 'core/creative/Creative';

interface CreativeStore {
  actionType: 'create' | 'edit' | 'bind';
  creative: any;
  creatives: any[];
  bindCreatives: any[];
  creativesPermission: { [key: string]: boolean };
  showCreativeManager: boolean;
  showBindCreativeManager: boolean;
  addCreative: (creative: CreativeOfCampaign) => void;
  handleAddCreatives: (creatives: any[]) => void;
  handleAddBindCreatives: (creatives: any[]) => void;
  removeCreative: (id: number) => void;
  updateCreative: (creative: CreativeOfCampaign) => void;
  resetCreativeStore: () => void;
  setCreativesPermission: (creativesPermission: {
    [key: string]: boolean;
  }) => void;
  openCreativeManager: (open: boolean) => void;
  openBindCreativeManager: (open: boolean) => void;
  handleChangeActionType: (actionType: 'create' | 'edit' | 'bind') => void;
  handleChangeCreative: (newCreative) => void;
}

const useCreativeStore = create<CreativeStore>((set) => ({
  actionType: 'create',
  creative: {} as any,
  creatives: [],
  bindCreatives: [],
  creativesPermission: {},
  showCreativeManager: false,
  showBindCreativeManager: false,
  addCreative: (creative) =>
    set((state) => ({ creatives: [...state.creatives, creative] })),
  handleAddCreatives: (creatives) =>
    set(() => ({ creatives: creatives.reverse() })),
  handleAddBindCreatives: (creatives) =>
    set(() => ({ bindCreatives: creatives.reverse() })),
  removeCreative: (id) =>
    set((state) => ({ creatives: state.creatives.filter((c) => c.id !== id) })),
  updateCreative: (updatedCreative) =>
    set((state) => ({
      creatives: state.creatives.map((c) =>
        c.id === updatedCreative.id ? updatedCreative : c,
      ),
    })),
  resetCreativeStore: () =>
    set(() => ({
      creatives: [],
      creative: {} as any,
      bindCreatives: [],
      creativesPermission: {},
      showCreativeManager: false,
      showBindCreativeManager: false,
    })),
  setCreativesPermission: (creativesPermission) =>
    set(() => ({ creativesPermission })),
  openCreativeManager: (open) => set(() => ({ showCreativeManager: open })),
  openBindCreativeManager: (open) =>
    set(() => ({ showBindCreativeManager: open })),
  handleChangeActionType: (actionType) => set(() => ({ actionType })),
  handleChangeCreative: (newCreative) => set({ creative: newCreative }),
}));

export default useCreativeStore;
